/* src/app/modules/portal/components/mi-applications/mi-applications.component.scss */
:host {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
}
:host sh-tool {
  --sh-icon-font-size-m: 2.5rem;
}
.landing-page:hover > sh-text {
  background: rgba(0, 0, 0, 0.12);
}
.landing-page > sh-text {
  background: rgba(0, 0, 0, 0.065);
  border-radius: var(--sh-tool-border-radius);
}
.app {
  width: 200px;
  background: #efefef;
  display: flex;
  flex-direction: column;
}
sh-text.custom-tool {
  width: var(--sh-tool-width);
  min-width: var(--sh-tool-width);
  max-width: var(--sh-tool-width);
  height: var(--sh-tool-height);
  min-height: var(--sh-tool-height);
  max-height: var(--sh-tool-height);
  padding: var(--sh-tool-padding);
  background: rgba(var(--ui-1), var(--opacity-7));
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) background-color;
  overflow: hidden;
  -webkit-line-clamp: 4;
  word-break: break-word;
  text-overflow: ellipsis;
  text-align: center;
  display: flex;
  align-items: center;
  font-size: var(--sh-tool-icon-value-label-font-size);
  text-wrap: pretty;
}
sh-text.custom-tool:hover {
  background: rgba(var(--ui-1), var(--opacity-6));
}
.apps {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
}
.link-title {
  font-weight: 600;
  margin: 0.5rem;
}
a,
a:hover,
a:visited {
  color: var(--text-primary);
  text-decoration: none;
}
img {
  width: calc(100% - 1rem);
  object-fit: contain;
  height: 100px;
  background: #ffffff;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
ul {
  padding: 0.5rem;
  margin: 0px;
}
li {
  list-style-type: none;
}
[screen-phone] :host-context .app {
  width: calc(50% - 0.5rem);
}
[screen-phone] :host-context ul li {
  width: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=mi-applications.component.css.map */
